/**
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
    var imageContainers = document.querySelectorAll(classElemsToHide);
    imageContainers.forEach(function(imageContainer) {
        imageContainer.style.display = 'none';
    });
    document.querySelector(classElemToShow).style.display = 'grid';
}

/**
 * Add background filter on hover over mega menu links.
 */
function hoverBgFilter() {
    const header = document.querySelector('.mm-header');
    const megaMenuLinks = document.querySelectorAll('.mm-header-link-mega-menu');
    const filter = document.querySelector('.mm-filter-mega-menu');

    megaMenuLinks.forEach(megaMenuLink => {
        megaMenuLink.addEventListener('mouseenter', () => {
            filter.classList.add("active");
        });
        header.addEventListener('mouseleave', () => {
            filter.classList.remove("active");
        });
    });
}

/**
 * Show background filter.
 */
function showBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.style.zIndex = 'var(--index)';
    filter.classList.add("active");
}

/**
 * Hide background filter.
 */
function hideBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.style.removeProperty('z-index');
    filter.classList.remove("active");
}

/**
 * Open external links in a new tab unless it's the consent modale.
 */
function externalLink() {
	var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].classList.contains('consent-wrapper') && links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
}

// SEARCH //
/**
 * Show the search bar and related UI changes.
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
function mmShowSearch(clickedElem) {
	const search = document.querySelector('.mm-header-search-container-mobile');
	const filter = document.querySelector('.mm-filter-mega-menu');
	search.classList.add('mm-open');
	filter.classList.add("active");
	document.querySelector("html").classList.add("stop-scrolling");

	setTimeout(() => {
		document.getElementById('Search').focus();
	}, '1000');

	document.getElementById('predictive-search').addEventListener("touchstart", (event) => {
		setTimeout(() => {
			document.getElementById('Search').blur();
		}, 500);
	});
}

// splide mobile products search
function searchSplideProducts() {
	var splideElem = document.querySelector(".mm-search-splide");

	if (splideElem) {
		var main = new Splide(splideElem, {
		type: "slide",
		rewind: false,
		arrows: false,
		pagination: false,
		gap: '12px',
		drag: true,
		perPage: 1,
		perMove: 1,
		fixedWidth: 155,
		});

		main.mount();
	}
}

document.addEventListener('DOMContentLoaded', function() {
	searchSplideProducts();
});

/**
 * Toggle the mobile menu.
 */
function mmMobileMenu() {
	if (window.innerWidth <= 1200) {
		const filter = document.querySelector('.mm-filter-mega-menu');
		const header = document.querySelector("header");
		const icon = document.querySelector(".mm-header-burger");
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
		const mobileMenuSecondary = document.querySelector(".mm-mobile-menu-wrapper .mm-header-mobile-sublinks");
		let headerMenu = document.querySelector('.mm-header');
		let headerHeight = headerMenu.offsetHeight;
		let headerMenuTop = headerMenu.getBoundingClientRect().top;

		// Ouvrir le menu mobile si ce n'est pas déjà ouvert
		if (!mobileMenu.classList.contains("mm-menu-open")) {
			filter.classList.add("active");
			header.classList.add("mm-open");
			icon.classList.add("mm-open");
			mobileMenu.classList.add("mm-menu-open");
			document.querySelector("html").classList.add("stop-scrolling");
			mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
			mobileMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
			mobileMenuSecondary.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;

			// Assurez-vous que le mobile menu est en haut avec z-index
			mobileMenu.style.zIndex = '10';  // Le mobile menu est au-dessus du search
		}
	}
}

function mmHideSearch() {
	const search = document.querySelector('.mm-header-search-container-mobile');
	const filter = document.querySelector('.mm-header-bg-filter');
	const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

	search.classList.remove('mm-open');
	filter.classList.remove('active');
	
	if (!mobileMenu.classList.contains("mm-menu-open")) {
		document.querySelector('html').classList.remove('stop-scrolling');
	}

	var searchInput = document.getElementById('Search');
	searchInput.value = '';
	var event = new Event('input');
	searchInput.dispatchEvent(event);
}

// Fonction d'ouverture du search mobile
function openMobileSearch() {
	const mobileSearchContainer = document.querySelector('.mm-header-search-container-mobile');
    const mobileMenu = document.querySelector('.mm-mobile-menu-wrapper');

        // Ouvrir le search mobile
        mobileSearchContainer.classList.add('mm-open');
        document.querySelector('html').classList.add('stop-scrolling');

        // Assurez-vous que le search est au-dessus
        mobileSearchContainer.style.zIndex = '15'; // Le search est au-dessus du mobile menu

        // Vérifie si le mobile menu est ouvert
        if (mobileMenu.classList.contains('mm-menu-open')) {
            // Si le mobile menu est déjà ouvert, ne rien faire (il reste ouvert)
            console.log("Le menu mobile reste ouvert.");
            mobileMenu.classList.add("mm-menu-open");
        }

}

// Fonction de fermeture du search mobile
function closeMobileSearch() {
    const mobileSearchContainer = document.querySelector('.mm-header-search-container-mobile');
    const mobileMenuWrapper = document.querySelector('.mm-mobile-menu-wrapper');

    // Fermer le search
    if (mobileSearchContainer) {
        mobileSearchContainer.classList.remove('mm-open');

        // Vérifie si 'mm-menu-open' est présent dans 'mm-mobile-menu-wrapper' avant d'enlever 'stop-scrolling'
        if (!mobileMenuWrapper || !mobileMenuWrapper.classList.contains('mm-menu-open')) {
            document.querySelector('html').classList.remove('stop-scrolling');
            document.querySelector('body').classList.remove('stop-scrolling');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
	const searchOpenButton = document.getElementById('mmSearchOpen');
	const searchClearButton = document.getElementById('mmSearchClear');
	const bgFilter = document.querySelector('.mm-header-bg-filter');

	if (searchOpenButton) {
		searchOpenButton.addEventListener('click', function() {
			openMobileSearch();
		});
	}

	if (searchClearButton) {
		searchClearButton.addEventListener('click', closeMobileSearch);
	}

	if (bgFilter) {
		bgFilter.addEventListener('click', closeMobileSearch);
	}
});

/**
* Close the mobile menu.
*/
function mmCloseMobileMenu() {
	if (window.innerWidth <= 1200) {
		const header = document.querySelector("header");
		const icon = document.querySelector(".mm-header-burger");
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
		const mobileSearchContainer = document.querySelector(".mm-header-search-container-mobile");

		// Vérifier si le mobile menu est ouvert avant de le fermer
		if (mobileMenu.classList.contains("mm-menu-open")) {
			header.classList.remove("mm-open");
			icon.classList.remove("mm-open");
			mobileMenu.classList.remove("mm-menu-open");

			// Enlever 'stop-scrolling' uniquement si 'mm-header-search-container-mobile' ne contient pas 'mm-open'
			if (!mobileSearchContainer || !mobileSearchContainer.classList.contains("mm-open")) {
				document.querySelector("html").classList.remove("stop-scrolling");
			}

			hideBgFilter();
		}
	}
}

/**
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowNext(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

/**
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowPrev(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

/**
 * Handle dropdown behavior.
 */
function handleDropdown() {
    const dropWrapper = document.querySelectorAll('.mm-drop-wrapper');

    // Open the first dropdown by default
    // if (dropWrapper.length > 0) {
    //     dropWrapper[0].classList.add('active');
    //     dropWrapper[0].nextElementSibling.style.maxHeight = dropWrapper[0].nextElementSibling.scrollHeight + 'px';
    // }

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            dropWrapper.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    el.nextElementSibling.style.maxHeight = null;
                }
            });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

function setupThumbnailHover() {
    // Sélectionne toutes les cartes produits
    var productCards = document.querySelectorAll('.mm-products-card');

    // Pour chaque carte produit, ajoute les événements de survol aux vignettes
    productCards.forEach(function(ProductCard) {
        // Sélectionne l'image principale, les vignettes et le loader
        var ProductCardImg = ProductCard.querySelector('.mm-main-img');
        var thumbnails = ProductCard.querySelectorAll('.mm-products-card-variant');
        var loader = ProductCard.querySelector('.mm-image-loader');

        // Ajoute un événement de survol pour chaque vignette
        thumbnails.forEach(function(thumbnail) {
            thumbnail.addEventListener('mouseover', function() {
                // Change la source de l'image principale par celle de la vignette survolée
                var newSrc = thumbnail.getAttribute('data-variant');

				// Afficher le loader et masquer l'image pendant le chargement
                loader.style.display = 'block';

                // Change l'image principale et ajoute un événement pour détecter quand elle est chargée
                ProductCardImg.onload = function() {
                    // Masquer le loader et afficher l'image une fois qu'elle est chargée
                    loader.style.display = 'none'; // Affiche l'image principale
                };

                // Mettre à jour la source de l'image
                ProductCardImg.setAttribute('src', newSrc);
                ProductCardImg.setAttribute('srcset', newSrc);
            });

            thumbnail.addEventListener('mouseout', function() {
                // Restaure l'image principale à son état initial
                var originalSrc = ProductCard.getAttribute('data-original-img');

                // Afficher le loader et masquer l'image pendant le chargement
                loader.style.display = 'block';

                ProductCardImg.onload = function() {
                    // Masquer le loader et afficher l'image une fois qu'elle est chargée
                    loader.style.display = 'none';
                };

                // Mettre à jour la source de l'image principale
                ProductCardImg.setAttribute('src', originalSrc);
                ProductCardImg.setAttribute('srcset', originalSrc);
            });
        });
    });
}

/**
 * Set the document height CSS variable to the current window height.
 */
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// Custom element for product recommendations
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

document.addEventListener("DOMContentLoaded", (event) => {
    hoverBgFilter();
    handleDropdown();
	externalLink();
	setupThumbnailHover();
});

window.addEventListener('resize', documentHeight);
documentHeight();

// Loader
function mmLoadThis(button) {
	button.classList.add('mm-loading')
}

window.addEventListener('DOMContentLoaded', (event) => {
    const images = document.querySelectorAll(".slide-image");

    images.forEach((slideImage) => {
        gsap.to(slideImage.querySelector(".slide-image-cover"), {
            yPercent: 30,
            ease: "none",
            scrollTrigger: {
                trigger: slideImage,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            }
        });
    });
});

/**
 * GSAP for wheel
 */
document.addEventListener("DOMContentLoaded", function() {
    // Sélectionnez toutes les divs avec la classe mm-breaking-block
    const blocks = document.querySelectorAll(".mm-breaking-block");

    // Pour chaque bloc, configurez une animation GSAP
    blocks.forEach(block => {
        gsap.to(block.querySelector(".mm-icon-wheel"), {
            rotation: 180,
            scrollTrigger: {
                trigger: block,
                start: "top bottom",
                end: "bottom top",
                scrub: 1.2,
                // markers: true,
            }
        });
    });
});

/**
 * GSAP for cta filter mobile
 */
document.addEventListener("DOMContentLoaded", function() {
    // Sélectionnez l'élément à manipuler
    const stickyElement = document.querySelector(".mm-grid-first-container-mobile-filter-sticky");

    // Récupérez les valeurs des variables CSS
    const cubicBezierLong = getComputedStyle(document.documentElement).getPropertyValue('--cubic-bezier-long').trim();
    const durationShort = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--duration-short'));

    // Configurez l'animation GSAP
    gsap.to(stickyElement, {
        scrollTrigger: {
            trigger: ".mm-grid", // Déclencheur pour l'animation
            start: "top top", // Commence lorsque le haut de .mm-grid atteint le haut de la page
            end: "bottom-=50px bottom", // Se termine lorsque le bas de .mm-grid atteint le haut de la page
            scrub: 1.2, // Synchronise l'animation avec le défilement
            ease: cubicBezierLong, // Appliquez la valeur récupérée pour ease
            duration: durationShort / 1000, // Diviser par 1000 pour convertir en secondes
            onEnter: () => gsap.to(stickyElement, {
                opacity: 1,
                bottom: "10px",
            }),
            onLeave: () => gsap.to(stickyElement, {
                opacity: 0,
                bottom: "-40px",
            }),
            onLeaveBack: () => gsap.to(stickyElement, {
                opacity: 0,
                bottom: "-40px",
            }),
            onEnterBack: () => gsap.to(stickyElement, {
                opacity: 1,
                bottom: "10px",
            }),
            // markers: true, // Décommentez pour afficher les marqueurs de débogage
        }
    });
});

const mmInitVideoPlayer = () => {
    const videoFilters = document.querySelectorAll(".mm-grid-marque-media-filter");
    const titlePlayers = document.querySelectorAll(".mm-grid-marque-media-title-player");

    // Fonction pour gérer l'activation/désactivation du mute
    const unmuteVideo = (video) => {
        video.muted = false;
    };

    // Fonction pour cacher les éléments au clic sur le player
    const hideElements = () => {
        videoFilters.forEach(filter => filter.style.display = "none");
        titlePlayers.forEach(title => title.style.display = "none");
    };

    // Fonction pour montrer les éléments au cas où on met en pause
    const showElements = () => {
        videoFilters.forEach(filter => filter.style.display = "");
        titlePlayers.forEach(title => title.style.display = "");
    };

    // Fonction pour jouer la vidéo et cacher le bouton de lecture
    const playVideo = (video, player) => {
        video.play();
        player.classList.add("mm-media-play-none"); 
        unmuteVideo(video);
        hideElements(); // Cacher le filtre et le titre
    };

    // Fonction pour mettre la vidéo en pause et afficher le bouton de lecture
    const pauseVideo = (video, player) => {
        video.pause();
        player.classList.remove("mm-media-play-none");
        showElements(); // Réafficher le filtre et le titre
    };

    // Fonction générique pour gérer l'interaction avec une vidéo et son bouton
    const handleVideoInteraction = (video, player) => {
        player.addEventListener("click", () => {
            if (video.paused) {
                playVideo(video, player);
            } else {
                pauseVideo(video, player);
            }
        });

        video.addEventListener("click", () => {
            pauseVideo(video, player);
        });
    };

    // Fonction pour initialiser le player vidéo desktop
    const initDesktopVideoPlayer = () => {
        const videoSections = document.querySelectorAll(".mm-grid-marque-media-container");

        videoSections.forEach((section) => {
            const videoDesktop = section.querySelector(".mm-grid-marque-media-video");
            const playerDesktop = section.querySelector(".mm-grid-marque-media-player");

            if (videoDesktop && playerDesktop) {
                handleVideoInteraction(videoDesktop, playerDesktop);
            }
        });
    };

    initDesktopVideoPlayer();
};

document.addEventListener("DOMContentLoaded", () => {
    mmInitVideoPlayer();
});

// COOKIES
function activateCookies() {
    const cookiesElems = document.querySelectorAll('#sd-cmp *');
    const clickEvent = new Event('click');
    cookiesElems.forEach(function(elem) {
        elem.dispatchEvent(clickEvent);
    })
}